import getMapData from "./_getMapData.js";
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size = data.size;
  return data.set(key, value), this.size += data.size == size ? 0 : 1, this;
}
export {
  mapCacheSet as default
};
//# sourceMappingURL=_mapCacheSet.js.map
